import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className='container mx-auto'>
            Not found
            <Link to={'/validation-software'}>Volver al inicio</Link>
        </div>
    );
}

export default NotFound;
